// extracted by mini-css-extract-plugin
export var videoPlayer = "embeddedVideo-module--video-player--7f07c";
export var videoWrapper = "embeddedVideo-module--video-wrapper--eca76";